import { createContext, useContext, useEffect, useState } from "react";
import { api, getToken, setToken, clearToken } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!getToken()) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => clearToken())
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password, remember = false) => {
    const { data } = await api.post("/auth/login", { email, password, remember_me: remember });
    setToken(data.token, remember);
    setUser(data.user);
    return data.user;
  };

  // Returns { status: "verification_sent", email } — no auto-login until verified.
  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password, origin_url: window.location.origin });
    return data;
  };

  // Used by the email-verification page to sign the user in after verifying.
  const setSession = (token, userObj, remember = true) => {
    setToken(token, remember);
    setUser(userObj);
  };

  const logout = () => {
    clearToken();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, setSession, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
